import { useFormikContext } from 'formik';
import React from 'react';
import { ActivityIndicator } from 'react-native';
import Button, { ButtonProps } from '../Button';

const FormButton: React.FC<ButtonProps> = ({
  children,
  disabled,
  ...props
}) => {
  const { isSubmitting, handleSubmit, isValid, dirty } = useFormikContext();

  return (
    <Button
      onPress={() => handleSubmit()}
      {...props}
      disabled={!dirty || !isValid || disabled || isSubmitting}
      endIcon={isSubmitting && <ActivityIndicator size='small' color='white' />}
    >
      {children}
    </Button>
  );
};

export default FormButton;
